module.exports = __webpack_public_path__ + "img/ring_r_0_null_1.70279c61.png";